const menuListTogglers = document.querySelectorAll('.menu-list-toggle')

if (menuListTogglers.length) {
    menuListTogglers.forEach(item => {
        const menuList = item.querySelector('.menu-list-wrapper')
        const clickToggle = item.querySelector('.click-toggle')

        item.isOpenState = false

        Object.defineProperty(item, 'isOpen', {
            get: () => {
                return item.isOpenState
            },
            set: (value) => {
                item.isOpenState = value

                if (menuList) {
                    menuList.style.display = value ? 'block' : 'none'
                }
            }
        })

        const hide = () => {
            item.dispatchEvent(new Event('hide'))
        }

        const show = () => {
            item.dispatchEvent(new Event('show'))
        }

        const toggle = () => {
            item.dispatchEvent(new Event('toggle'))
        }

        item.addEventListener('show', () => {
            item.isOpen = true
        })

        item.addEventListener('hide', () => {
            item.isOpen = false
        })

        item.addEventListener('toggle', () => {
            item.isOpen = !item.isOpen
        })

        if (clickToggle) {
            clickToggle.addEventListener('click', toggle)
        }

        useClickOutside(item, hide)
    })
}